/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockPolicyDto
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getTimeClockPolicy = () => {
/**
 * @summary Get the tenant's time clock rules (defaults when none are stored).
 */
const getApiV1TimeclockPolicy = (
    
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockPolicyDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockPolicyDto>(
      {url: `/api/v1/timeclock/policy`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Replace the tenant's time clock rules.
 */
const putApiV1TimeclockPolicy = (
    facilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockPolicyDto: FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockPolicyDto,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockPolicyDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockPolicyDto>(
      {url: `/api/v1/timeclock/policy`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockPolicyDto
    },
      options);
    }
  return {getApiV1TimeclockPolicy,putApiV1TimeclockPolicy}};
export type GetApiV1TimeclockPolicyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTimeClockPolicy>['getApiV1TimeclockPolicy']>>>
export type PutApiV1TimeclockPolicyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTimeClockPolicy>['putApiV1TimeclockPolicy']>>>
